import HiddenAlert from './HiddenAlert';

export default HiddenAlert;
